import { ADD_PRODUCT_ID } from './../../action-types/bookproperties';

export const STATE_KEY = 'productID';

export const photoBookId = (state = 0, action) => {
  switch (action.type) {
    case ADD_PRODUCT_ID: {
      return action.productID;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/photoBookId.js